import { ARTICLE as BrainrotHeistGuide } from './brainrot-heist-guide';
import { ARTICLE as BestTwoPlayerGamesOneKeyboard } from './best-2-player-games-one-keyboard';
import { ARTICLE as QuickGamesFiveMinuteBreak } from './quick-games-5-minute-break';
import { ARTICLE as BestSurvivalGamesOnline } from './best-survival-games-online';
import { ARTICLE as BestBrowserBattleRoyaleGames } from './best-browser-battle-royale-games';
import { ARTICLE as GamesForSchoolChromebooks } from './games-for-school-chromebooks';
import type { Article } from './types';

export type { Article };

/** Every article, newest first. Each lives in its own file in this folder. */
export const ARTICLES: Article[] = [
  BrainrotHeistGuide,
  BestTwoPlayerGamesOneKeyboard,
  QuickGamesFiveMinuteBreak,
  BestSurvivalGamesOnline,
  BestBrowserBattleRoyaleGames,
  GamesForSchoolChromebooks,
];

export const findArticle = (slug: string): Article | undefined => ARTICLES.find((a) => a.slug === slug);

/** Articles that feature a game, for links from its page. */
export const articlesFor = (gameId: string): Article[] =>
  ARTICLES.filter((a) => a.sections.some((s) => s.games?.includes(gameId)));
